import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Check, X } from "lucide-react";
import { type TriStateBoolean, toggleValueToTriState, triStateToToggleValue } from "@/lib/triState";

interface TriStateBooleanToggleProps {
  value: TriStateBoolean | undefined;
  onChange: (value: TriStateBoolean) => void;
  "aria-label"?: string;
}

export function TriStateBooleanToggle({ value, onChange, "aria-label": ariaLabel }: TriStateBooleanToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={triStateToToggleValue(value)}
      onValueChange={(next) => {
        // Radix emits "" when the active item is clicked again; keep the current value.
        const parsed = toggleValueToTriState(next);
        if (parsed !== undefined) onChange(parsed);
      }}
      className="justify-start"
      aria-label={ariaLabel}
    >
      <ToggleGroupItem
        value="null"
        className="data-[state=on]:bg-gray-200 data-[state=on]:text-gray-700"
      >
        Not Set
      </ToggleGroupItem>
      <ToggleGroupItem
        value="true"
        className="data-[state=on]:bg-green-100 data-[state=on]:text-green-700"
      >
        <Check className="mr-1 h-4 w-4" /> Yes
      </ToggleGroupItem>
      <ToggleGroupItem
        value="false"
        className="data-[state=on]:bg-red-100 data-[state=on]:text-red-700"
      >
        <X className="mr-1 h-4 w-4" /> No
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
